import PropTypes from "prop-types";

import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import {useGetMyProfileGamer} from "../../../hooks/useGetMyProfileGamer";
import usePagoMovilRegistration from "../../../hooks/usePagoMovilRegistration";
import {trackDepositButtonMenuClick} from "../../../providers/analytics";
import {useChangePassword} from "../../../store/useAccountScreens.store";
import {useBalanceStore} from "../../../store/useBalance.store";
import {useUserSupport} from "../../../store/useUserSupport.store";
import LanguageOption from "../../LanguageOption";
import ThemeToggle from "../../ThemeToggle/ThemeToggle";
import styles from "./DropdownRender.module.css";

const DropdownRender = ({handleLogout, dropdownStyle, handleClose}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const {data} = useGetMyProfileGamer();

  const close = () => {
    if (typeof handleClose === "function") {
      handleClose();
    }
  };

  const handleChangePasswordModal = useChangePassword.getState().handleChangePasswordModal;
  const handleBankAccountModal = useBalanceStore.getState().handleBankAccountModal;
  const handleWithdrawalModal = useBalanceStore.getState().handleWithdrawalModal;
  // eslint-disable-next-line no-unused-vars
  const handleTransferModal = useBalanceStore.getState().handleTransferModal;
  const handlePagoMovilListModal = useBalanceStore.getState().handlePagoMovilListModal;
  const handleSupportModal = useUserSupport.getState().handleSupportModal;

  const {triggerRegistrationModalIfNeeded} = usePagoMovilRegistration();

  const handleDepositAction = async () => {
    trackDepositButtonMenuClick();

    const modalTriggered = await triggerRegistrationModalIfNeeded("deposit", true);

    if (!modalTriggered) {
      handleBankAccountModal();
      close();
    }
  };

  const handleWithdrawalAction = async () => {
    const modalTriggered = await triggerRegistrationModalIfNeeded("withdrawal", true);

    if (!modalTriggered) {
      handleWithdrawalModal();
      close();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "var(--bg-main)",
        border: "none",
        color: "var(--text-primary)",
        padding: "0px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        borderRadius: "6px",
        width: dropdownStyle?.width || undefined,
      }}
    >
      <ul style={{listStyle: "none", padding: 0}}>
        <li>
          <div
            style={{
              display: "flex",
              border: "1px solid transparent",
              borderRadius: "4px",
              padding: "10px",
              gap: 5,
              backgroundcolor: "var(--text-secondary)",
            }}
          >
            <span>{t("points")}: </span>
            <span>
              <strong>{data?.points ?? "0"}pts</strong>
            </span>
          </div>
        </li>
        <li>
          <div
            style={{
              display: "flex",
              border: "1px solid transparent",
              borderRadius: "4px",
              padding: "10px",
              gap: 5,
              backgroundcolor: "var(--text-secondary)",
            }}
          >
            <span>{t("level")}: </span>
            <strong>{data?.level ?? "0"}</strong>
          </div>
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            navigate("/settings");
            close();
          }}
        >
          {t("profile")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            handlePagoMovilListModal();
            close();
          }}
        >
          {t("mobilePaidAccounts")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            navigate("/user/transactions");
            close();
          }}
        >
          {t("movements")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            navigate("/user/contacts");
            close();
          }}
        >
          {t("contact")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            handleChangePasswordModal();
            close();
          }}
        >
          {t("changePassword")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            navigate("/user/referrals");
            close();
          }}
        >
          {t("inviteFriend")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={handleDepositAction}
        >
          {t("deposit")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={handleWithdrawalAction}
        >
          {t("withdrawal")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            handleTransferModal();
            close();
          }}
        >
          {t("transfer")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={() => {
            handleSupportModal();
            close();
          }}
        >
          {t("support")}
        </li>
        <li
          className={styles.dropdown_menu}
          onClick={close}
        >
          <ThemeToggle />
        </li>
        <li className={styles.dropdown_menu}>
          {/* {t("language")} */}
          <LanguageOption />
        </li>
        <li
          style={{fontSize: "14px", paddingBottom: "2rem"}}
          className={styles.dropdown_menu}
          onClick={() => {
            handleLogout();
            close();
          }}
        >
          <b>{t("logout")}</b>
        </li>
      </ul>
    </div>
  );
};

DropdownRender.propTypes = {
  handleLogout: PropTypes.func.isRequired,
  dropdownStyle: PropTypes.object,
  handleClose: PropTypes.func,
};

export default DropdownRender;
